import baseEnglish from "./en.json";
import baseTurkish from "./tr.json";

type Messages = Record<string, string>;
const englishModules = import.meta.glob<Messages>("./refinement-*.en.json", {
  eager: true,
  import: "default",
});
const turkishModules = import.meta.glob<Messages>("./refinement-*.tr.json", {
  eager: true,
  import: "default",
});

export const englishMessages: Messages = Object.assign(
  {},
  baseEnglish,
  ...Object.values(englishModules),
);
export const turkishMessages: Messages = Object.assign(
  {},
  baseTurkish,
  ...Object.values(turkishModules),
);
